import { observable, action, makeAutoObservable, runInAction } from "mobx";
import { message, notification } from "antd";
import { createRoot } from "react-dom/client";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import Swal from "sweetalert2";
import { QRCodeCanvas } from "qrcode.react";
import jsPDF from 'jspdf';
import QRCode from 'qrcode';
import moment from 'moment';

class EventStore {

    @observable loading = false;
    @observable isSuccess = false;

    @observable perPage = 10;
    @observable hasMore = false;
    @observable page = 1;

    @observable perPageReceived = 10;
    @observable hasMoreReceived = false;
    @observable pageReceived = 1;

    @observable eventsTotalAmount = 0;

    @observable events = [];
    @observable eventRegistrations = [];
    @observable eventReceivedRegistrations = [];
    @observable votersAmounts = [];

    @observable event = {};
    @observable votersAmount = {};
    @observable eventRegistration = {};

    constructor() {
        makeAutoObservable(this);
    }

    @action
    createNewEvent = async (values) => {
        
        this.loading = true;
        
        try {
            const response = await axios.post(`/events/create_event.php`, values, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('QUNDRVNTX1RPS0VO')}`,
                }
            });

            if (response.status === 200) {
                notification.success({
                    top: 120,
                    message: 'Success!',
                    description: 'New Event Added'
                });

                Swal.fire({
                    title: "Good Job!",
                    icon: "success",
                    text: "New Event Added",
                    confirmButtonText: "Okay",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        //REDIRECT TO THE LIST OF TEAM LEADERS
                        setTimeout(function() {
                            window.location.replace('/events');
                        }, 500);
                    } 
                })
            }

        } catch (error) {
            console.log(error.response.data);
            if(error.response.data){
                notification.error({
                    top: 120,
                    message: 'User Registration Error',
                    description: error.response.data.message
                });
                message.error('User Registration Error');
            }
            runInAction(() => {
                this.isSuccess = false;
            });
        } finally {
            runInAction(() => {
                if(this.isSuccess == true){
                    this.loading = true;
                }else{
                    this.loading = false;
                }
                
            });
        }
    }

    @action
    fetchEvents = async () => {
        
        this.loading = true;
        
        try {
            const response = await axios.get(`/events/get_all_events.php?perPage=${this.perPage}&page=${this.page}&sortBy=DESC&orderBy=Date`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('QUNDRVNTX1RPS0VO')}`,
                }
            });

            if (response.status === 200) {
                runInAction(() => {
                    if(response.data){
                        this.events = response.data.data;
                        if (this.events && this.events.length < this.perPage) {
                            this.hasMore = false;
                        } else {
                            this.hasMore = true;
                        }
                    }
                });
            }
        } catch (error) {
            if(error.response.data){
                notification.error({
                    top: 120,
                    message: 'Fetching Events Error',
                    description: error.response.data.message
                });
                message.error('Fetching Events Error');
            }
            runInAction(() => {
                this.isSuccess = false;
            });
        } finally {
            runInAction(() => {
                this.loading = false
            });
        }
        
    }

    @action
    fetchEventsCalculate = async (startDate, endDate) => {
        
        this.loading = true;
        
        try {
            const response = await axios.get(`/events/get_all_events_calculate.php?perPage=${this.perPage}&page=${this.page}&sortBy=DESC&orderBy=Date&startDate=${startDate}&endDate=${endDate}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('QUNDRVNTX1RPS0VO')}`,
                }
            });

            if (response.status === 200) {
                runInAction(() => {
                    if(response.data){
                        this.eventsTotalAmount = response.data.totalAmount;
                    }
                });
            }
        } catch (error) {
            if(error.response.data){
                notification.error({
                    top: 120,
                    message: 'Fetching Events Error',
                    description: error.response.data.message
                });
                message.error('Fetching Events Error');
            }
            runInAction(() => {
                this.isSuccess = false;
            });
        } finally {
            runInAction(() => {
                this.loading = false
            });
        }
        
    }

    @action
    fetchEventsByTeamLeader = async () => {
        
        this.loading = true;
        
        try {
            const response = await axios.get(`/events/get_all_events_teamleader.php?perPage=${this.perPage}&page=${this.page}&sortBy=DESC&orderBy=Date`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('QUNDRVNTX1RPS0VO')}`,
                }
            });

            if (response.status === 200) {
                runInAction(() => {
                    if(response.data){
                        this.events = response.data.data;
                        if (this.events && this.events.length < this.perPage) {
                            this.hasMore = false;
                        } else {
                            this.hasMore = true;
                        }
                    }
                });
            }
        } catch (error) {
            if(error.response.data){
                notification.error({
                    top: 120,
                    message: 'Fetching Events Error',
                    description: error.response.data.message
                });
                message.error('Fetching Events Error');
            }
            runInAction(() => {
                this.isSuccess = false;
            });
        } finally {
            runInAction(() => {
                this.loading = false
            });
        }
        
    }

    @action
    fetchEventsRegistrationPending = async (eventID, teamLeaderID, status) => {
        
        this.loading = true;
        
        try {
            const response = await axios.get(`/events/get_all_events_registration.php?perPage=${this.perPage}&page=${this.page}&sortBy=ASC&eventID=${eventID}&teamLeaderID=${teamLeaderID}&status=${status}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('QUNDRVNTX1RPS0VO')}`,
                }
            });

            if (response.status === 200) {
                runInAction(() => {
                    if(response.data){
                        this.eventRegistrations = response.data.data;
                        if (this.eventRegistrations && this.eventRegistrations.length < this.perPage) {
                            this.hasMore = false;
                        } else {
                            this.hasMore = true;
                        }
                    }
                });
            }
        } catch (error) {
            if(error.response.data){
                notification.error({
                    top: 120,
                    message: 'Fetching Events Error',
                    description: error.response.data.message
                });
                message.error('Fetching Events Error');
            }
            runInAction(() => {
                this.isSuccess = false;
            });
        } finally {
            runInAction(() => {
                this.loading = false
            });
        }
        
    }

    @action
    fetchEventsRegistrationReceived = async (eventID, teamLeaderID, status) => {
        
        this.loading = true;
        
        try {
            const response = await axios.get(`/events/get_all_events_registration.php?perPage=${this.perPage}&page=${this.page}&sortBy=ASC&eventID=${eventID}&teamLeaderID=${teamLeaderID}&status=${status}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('QUNDRVNTX1RPS0VO')}`,
                }
            });

            if (response.status === 200) {
                runInAction(() => {
                    if(response.data){
                        this.eventReceivedRegistrations = response.data.data;
                        if (this.eventReceivedRegistrations && this.eventReceivedRegistrations.length < this.perPageReceived) {
                            this.hasMoreReceived = false;
                        } else {
                            this.hasMoreReceived = true;
                        }
                    }
                });
            }
        } catch (error) {
            if(error.response.data){
                notification.error({
                    top: 120,
                    message: 'Fetching Events Error',
                    description: error.response.data.message
                });
                message.error('Fetching Events Error');
            }
            runInAction(() => {
                this.isSuccess = false;
            });
        } finally {
            runInAction(() => {
                this.loading = false
            });
        }
        
    }

    @action
    fetchEventByID = async (id) => {
        
        this.loading = true;
        
        try {
            const response = await axios.get(`/events/get_event.php?id=${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('QUNDRVNTX1RPS0VO')}`,
                }
            });

            if (response.status === 200) {
                runInAction(() => {
                    if(response.data){
                        this.event = response.data.data;
                        if (this.event && this.event.length < this.perPage) {
                            this.hasMore = false;
                        } else {
                            this.hasMore = true;
                        }
                    }
                });
            }
        } catch (error) {
            if(error.response.data){
                notification.error({
                    top: 120,
                    message: 'Fetching Voters Error',
                    description: error.response.data.message
                });
                message.error('Fetching Voters Error');
            }
            runInAction(() => {
                this.isSuccess = false;
            });
        } finally {
            runInAction(() => {
                this.loading = false
            });
        }
        
    }

    @action
    updateEvent = async (values, id) => {
        
        this.loading = true;
        
        try {
            const response = await axios.patch(`/events/update_event.php?id=${id}`, values, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('QUNDRVNTX1RPS0VO')}`,
                }
            });

            if (response.status === 201) {
                notification.success({
                    top: 120,
                    message: 'Success!',
                    description: 'Event Updated'
                });

                Swal.fire({
                    title: "Good Job!",
                    icon: "success",
                    text: "Event Updated",
                    confirmButtonText: "Okay",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                })
            }

        } catch (error) {
            if(error.response.data){
                notification.error({
                    top: 120,
                    message: 'Edit Event Failure.',
                    description: error.response.data.message
                });
                message.error('Edit Event Failure.');
            }
            runInAction(() => {
                this.isSuccess = false;
            });
        } finally {
            runInAction(() => {
                this.loading = false
            });
        }
    }

    @action
    scanQRRegisteredUser = async (displayedID, eventID, teamLeaderID) => {
        
        this.loading = true;

        const datapost = {
            displayedID: displayedID,
            eventID: eventID
        }
        
        try {
            const response = await axios.patch(`/events/update_event_qr_user.php`, datapost, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('QUNDRVNTX1RPS0VO')}`,
                }
            });

            if (response.status === 201) {
                notification.success({
                    top: 120,
                    message: 'Success!',
                    description: 'Event Updated'
                });

                Swal.fire({
                    title: "Good Job!",
                    icon: "success",
                    text: "ID has been scanned successfully.",
                    confirmButtonText: "Okay",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                }).then((result) => {
                    if (result.isConfirmed) {

                        //REDIRECT TO THE TOP UP TEAM LEADERS
                        // setTimeout(function() {
                        //     window.location.reload();
                        // }, 200);
                        this.fetchEventsRegistrationPending(eventID, teamLeaderID, 'PENDING');
                        this.fetchEventsRegistrationReceived(eventID, teamLeaderID, 'RECEIVED');
                    } 
                })
            }

        } catch (error) {
            if(error.response.data){
                notification.error({
                    top: 120,
                    message: 'Redeeming Cash/Item Error',
                    description: error.response.data.message
                });
                message.error('Redeem Cash/Item Error.');
            }
            runInAction(() => {
                this.isSuccess = false;
            });
        } finally {
            runInAction(() => {
                this.loading = false
            });
        }
    }

    @action
    topupVotersCash = async (values, id) => {
        
        this.loading = true;

        const datapost = {
            votersamount: values
        }
        
        try {
            const response = await axios.post(`/votersamount/topup_votersamount_cash.php`, datapost, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('QUNDRVNTX1RPS0VO')}`,
                }
            });

            if (response.status === 201) {
                notification.success({
                    top: 120,
                    message: 'Good Job!',
                    description: 'Top Up Voters Successful'
                });

                Swal.fire({
                    title: "Good Job!",
                    icon: "success",
                    text: "Top Up Voters Successful",
                    confirmButtonText: "Okay",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        localStorage.removeItem(`ayudacash_${id}`);
                        localStorage.removeItem(`adminayudacash_${id}`);

                        //REDIRECT TO THE TOP UP TEAM LEADERS
                        setTimeout(function() {
                            window.location.reload();
                        }, 200);
                    } 
                })
            }

        } catch (error) {
            if(error.response.data){
                notification.error({
                    top: 120,
                    message: 'Top Up Voters Failure.',
                    description: error.response.data.message
                });
                message.error('Top Up Voters Failure.');
            }
            runInAction(() => {
                this.isSuccess = false;
            });
        } finally {
            runInAction(() => {
                this.loading = false
            });
        }
    }

    
    @action
    topupVotersItem = async (values, id) => {
        
        this.loading = true;

        const datapost = {
            votersamount: values
        }
        
        try {
            const response = await axios.post(`/votersamount/topup_votersamount_item.php`, datapost, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('QUNDRVNTX1RPS0VO')}`,
                }
            });

            if (response.status === 201) {
                notification.success({
                    top: 120,
                    message: 'Good Job!',
                    description: 'Top Up Voters Successful'
                });

                Swal.fire({
                    title: "Good Job!",
                    icon: "success",
                    text: "Top Up Voters Successful",
                    confirmButtonText: "Okay",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        localStorage.removeItem(`ayudaitems_${id}`);
                        localStorage.removeItem(`itemdata_${id}`);

                        //REDIRECT TO THE TOP UP TEAM LEADERS
                        setTimeout(function() {
                            window.location.reload();
                        }, 200);
                    } 
                })
            }

        } catch (error) {
            if(error.response.data){
                notification.error({
                    top: 120,
                    message: 'Top Up Voters Failure.',
                    description: error.response.data.message
                });
                message.error('Top Up Voters Failure.');
            }
            runInAction(() => {
                this.isSuccess = false;
            });
        } finally {
            runInAction(() => {
                this.loading = false
            });
        }
    }

    @action
    createUserEventRegistration = async (values, teamLeaderName) => {
        
        this.loading = true;

        const registrationpost = {
            ...values,
            hasItem : values.itemAmount ? 1 : 0,
            hasCash : values.cashAmount ? 1 : 0,
        }
        
        try {
            const response = await axios.post(`/events/create_event_registration.php`, registrationpost, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('QUNDRVNTX1RPS0VO')}`,
                }
            });

            if (response.status === 200) {

                if(response.data){
                    this.eventRegistration = response.data.data;

                    notification.success({
                        top: 120,
                        message: 'Good Job!',
                        description: 'New User Registered'
                    });

                    Swal.fire({
                        title: "Good Job!",
                        icon: "success",
                        text: "New User Registered! Do you want to print the QR Code?",
                        confirmButtonText: "Print Claim Slip",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    }).then(async (result) => {

                        if (result.isConfirmed) {
                            const eventData = response.data.data;
                            
                            // Ensure displayedID exists
                            // const qrData = eventData.displayedID || "No ID Available";

                            const jsonData = JSON.stringify({
                                displayedID: eventData.displayedID,
                                fullName: eventData.name, 
                                address: eventData.address,
                                precint: eventData.precint,
                                gender: eventData.gender
                            });

                            // Convert to base64 string
                            const base64QRData = btoa(jsonData);
        
                            // Generate QR Code as Data URL
                            const qrCodeUrl = await QRCode.toDataURL(base64QRData);
        
                            // Create PDF
                            // const pdf = new jsPDF();

                            const pdf = new jsPDF({
                                orientation: 'portrait',
                                unit: 'mm',
                                format: [58, 150] // 58mm width, 100mm height (adjustable)
                            });

                            // Get today's date
                            const currentDate = moment().format("YYYY-MM-DD");
                            
                            // Title
                            pdf.setFontSize(12);
                            pdf.text('CLAIM STUB', 5, 10);

                            let ytitlePosition = 15; // Start below "CLAIM STUB"

                            pdf.setFontSize(10);
                            // **Wrap Event Name**
                            const eventNameLines = pdf.splitTextToSize(eventData.eventName, 48); // Limit width
                            pdf.text(eventNameLines, 5, ytitlePosition);
                            ytitlePosition += eventNameLines.length * 5; // Adjust height dynamically

                            // **Wrap Team Leader Name**
                            const teamLeaderLines = pdf.splitTextToSize('Team Leader: '+teamLeaderName, 48); // Limit width
                            pdf.text(teamLeaderLines, 5, ytitlePosition);
                            ytitlePosition += teamLeaderLines.length * 5; // Adjust height dynamically

                            pdf.text(currentDate, 5, ytitlePosition);
                            ytitlePosition += 6; // Move down
        
                            // Add QR Code to PDF (centered)
                            // pdf.addImage(qrCodeUrl, 'PNG', 3, 20, 42, 42); // Position & size

                            const qrSize = 45; // Set QR code size to 45mm
                            const qrX = (58 - qrSize) / 2; // Center the QR Code
                            const qrY = ytitlePosition + 5;
                            pdf.addImage(qrCodeUrl, 'PNG', qrX, qrY, qrSize, qrSize);

                            // Text below QR Code
                            pdf.setFontSize(10);
                            let yPosition = qrY + qrSize + 10;

                            pdf.text(`ID: ${eventData.displayedID}`, 5, yPosition);
                            yPosition += 6;

                            // Wrap long text properly
                            const wrapText = (label, value) => {
                                const textLines = pdf.splitTextToSize(`${label}: ${value}`, 48); // Limit width
                                pdf.text(textLines, 5, yPosition);
                                yPosition += textLines.length * 5;
                            };

                            // Add details
                            wrapText('Name', eventData.name);
                            wrapText('Address', eventData.address);
                            wrapText('Precinct', eventData.precint);
                            wrapText('Gender', eventData.gender);
        
                            // Generate and show preview
                            const pdfBlob = pdf.output('blob');
                            const pdfUrl = URL.createObjectURL(pdfBlob);
                            pdf.autoPrint();
                            window.open(pdfUrl, "_blank");

                            setTimeout(() => {
                                window.location.reload();
                            }, 500);
        
                            // Ask to print
                            // Swal.fire({
                            //     title: "Print Now?",
                            //     text: "Do you want to print the QR Code?",
                            //     icon: "question",
                            //     showCancelButton: true,
                            //     confirmButtonText: "Yes, Print",
                            //     cancelButtonText: "No"
                            // }).then((finalPrint) => {
                            //     if (finalPrint.isConfirmed) {
                            //         pdf.autoPrint();
                            //         window.open(pdfUrl, "_blank");
                            //     }
                            //     setTimeout(() => {
                            //         window.location.reload();
                            //     }, 500);
                            // });
                        }
                    });
                }
            }

        } catch (error) {
            console.log(error.response.data);
            if(error.response.data){
                notification.error({
                    top: 120,
                    message: 'Event User Registration Error',
                    description: error.response.data.message
                });
                message.error('Event User Registration Error');
            }
            runInAction(() => {
                this.isSuccess = false;
            });
        } finally {
            runInAction(() => {
                if(this.isSuccess == true){
                    this.loading = true;
                }else{
                    this.loading = false;
                }
                
            });
        }
    }
    
}

export default EventStore;
